module.exports = (state, action) => {
  const { logged } = action.payload
  state.logged = logged
}
